/**
 * Конвертирует строку UTC offset в миллисекунды с учётом знака.
 * @param {string} utc - Смещение UTC (например "+03:00").
 * @returns {number} Смещение в миллисекундах.
 */
const utcToMs = (utc) => {
  const sign = utc.startsWith('-') ? -1 : 1;
  const [hours, minutes] = utc.slice(1).split(':').map(Number);
  return sign * (hours * 60 + minutes) * 60 * 1000;
};

export default utcToMs;
